import { getUnsplashApi, downloadEndpoint } from "../apis";

export const fetchRandomPhoto = () => {
    const ACCESS_KEY = process.env.REACT_APP_UNSPLASH_ACCESS_KEY;

    return getUnsplashApi(`photos/random?client_id=${ACCESS_KEY}&count=${1}`);
}

export const fetchMorePhotos = () => {
    const ACCESS_KEY = process.env.REACT_APP_UNSPLASH_ACCESS_KEY;

    return getUnsplashApi(`photos/random?client_id=${ACCESS_KEY}&count=${36}`);
}

export const fetchSearchImages = (searchTerm) => {
    const ACCESS_KEY = process.env.REACT_APP_UNSPLASH_ACCESS_KEY;

    return getUnsplashApi(`search/photos?client_id=${ACCESS_KEY}&page=1&query=${searchTerm}&count=12`);
}

export const triggerDownload = (downloadUrl) => {
    const ACCESS_KEY = process.env.REACT_APP_UNSPLASH_ACCESS_KEY;
    const photosDownloadUrl = downloadUrl.photosDownloadUrl;
    return downloadEndpoint(`${photosDownloadUrl}?client_id=${ACCESS_KEY}`);
}